<ng-container *ngIf="isRebrandingBanner; then rebrandedTemplateV1 else originalTemplate"></ng-container>

<ng-template #originalTemplate>
  <section class="tw-mx-4 tw-mb-4 bdr-rad-15 explore tw-p-4 tw-shadow-z1" [routerLink]="orderUrl" (click)="handleClick()">
    <div class="header tw-flex tw-items-center">
      <img class="tw-flex-none tw-h-12 tw-w-12 tw-rounded-full tw-mr-3" src="/assets/images/delivered.gif" />
      <div class="tw-font-body tw-font-bold tw-text-400 tw-mr-2 tw-items-center tw-flex w50 tw-min-h-12" i18n="@@kitDelivered" *ngIf='order.get("type") === ApiClientConstant.Order.Type.REGIMEN'> We have delivered your treatment kit </div>
      <div class="tw-font-body tw-font-bold tw-text-400 tw-mr-2 tw-items-center tw-flex w50 tw-min-h-12" i18n="@@orderDelivered" *ngIf='order.get("type") !== ApiClientConstant.Order.Type.REGIMEN'> We have delivered your order </div>
      <div class="click-icon tw-border tw-border-gray-500 tw-rounded-full tw-w-8 tw-h-8 tw-absolute tw-right-2">
        <cs-icon class="tw-absolute" [iconName]="'chevron_right_green'"></cs-icon>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #rebrandedTemplateV1>
  @if (!orderStatusBannerExp) {
    <section class="tw-rounded-3 tw-mx-4 tw-mb-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border" style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);" [routerLink]="orderUrl" (click)="handleClick()">
      @if (shouldShowPartialOrderCancellationUI) {
        <div class="header tw-flex tw-items-center">
          <div>
            <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_delivered'"></cs-icon>
          </div>
          <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
            <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1">
              <span i18n="@@orderDeliveredTag">Order Delivered</span>
              <cs-icon class="tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
            </div>
            @if (cancelledProducts?.length === 1) {
              <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productRemovedByYourDoctor">{{cancelledProducts?.length}} product removed by your doctor </p>
            } @else if (cancelledProducts?.length > 1) {
              <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productsRemovedByYourDoctor">{{cancelledProducts?.length}} products removed by your doctor </p>
            }
          </div>
        </div>
      } @else {
        <div class="header tw-flex tw-items-center">
          <div>
            <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_delivered'"></cs-icon>
          </div>
          <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
            <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1">
              <span i18n="@@orderDeliveredTag">Order Delivered</span>
              <cs-icon class="tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
            </div>
            <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@yourOrderIsDelivered" *ngIf='order.get("type") !== ApiClientConstant.Order.Type.REGIMEN'>
              Your order is Delivered
            </div>
            <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@yourKitIsDelivered" *ngIf='order.get("type") === ApiClientConstant.Order.Type.REGIMEN'>
              Your treatment kit is delivered
            </div>
          </div>
        </div>
      }
    </section>
  } @else {
    <section class="tw-rounded-3 tw-mx-4 tw-mb-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border" style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);" [routerLink]="orderUrl" (click)="handleClick()">
      @if (shouldShowPartialOrderCancellationUI) {
        <div class="header tw-flex tw-items-center">
          <div class="tw-relative tw-flex-none tw-h-12 tw-w-12 tw-rounded-lg tw-border tw-border-gray-200 tw-overflow-hidden tw-bg-gray-100">
            @for (image of productImages; track image; let i = $index) {
              <img
                class="tw-absolute tw-inset-1 tw-h-10 tw-w-10 tw-object-contain tw-transition-opacity tw-duration-500"
                [src]="image"
                [class.tw-opacity-100]="i === currentImageIndex"
                [class.tw-opacity-0]="i !== currentImageIndex"
              />
            }
          </div>
          <div class="tw-ml-2 tw-flex tw-flex-col tw-justify-center tw-gap-1">
            <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex">
              <span i18n="@@partialProductsDeliveredExpTag">{{orderedProductsCount}}/{{totalProductsCount}} Products delivered</span>
              <cs-icon class="tw-h-4 tw-aspect-square tw-ml-2 tw-flex-none" [iconName]="'chevron_right_teal'"></cs-icon>
            </div>
            @if (cancelledProducts?.length === 1) {
              <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productRemovedByYourDoctor">{{cancelledProducts?.length}} product removed by your doctor </p>
            } @else if (cancelledProducts?.length > 1) {
              <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productsRemovedByYourDoctor">{{cancelledProducts?.length}} products removed by your doctor </p>
            }
          </div>
        </div>
      } @else {
        <div class="header tw-flex tw-items-center tw-mt-[-2px]">
          <div class="tw-relative tw-flex-none tw-h-12 tw-w-12 tw-overflow-hidden tw-bg-gray-100"
            [ngClass]="order.get('type') === ApiClientConstant.Order.Type.REGIMEN ? 'tw-rounded-1.5 tw-border tw-border-white' : 'tw-rounded-lg tw-border tw-border-gray-200'">
            @for (image of productImages; track image; let i = $index) {
              <img
                class="tw-absolute tw-transition-opacity tw-duration-500"
                [ngClass]="order.get('type') === ApiClientConstant.Order.Type.REGIMEN ? 'tw-inset-0 tw-w-full tw-h-full tw-object-cover' : 'tw-inset-1 tw-h-10 tw-w-10 tw-object-contain'"
                [src]="image"
                [class.tw-opacity-100]="i === currentImageIndex"
                [class.tw-opacity-0]="i !== currentImageIndex"
              />
            }
          </div>
          <div class="tw-ml-2 tw-flex tw-flex-col tw-justify-center tw-gap-1">
            <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex">
              <span i18n="@@treatmentKitDeliveredExpTag" *ngIf='order.get("type") === ApiClientConstant.Order.Type.REGIMEN'>Treatment Kit delivered</span>
              <span *ngIf='order.get("type") !== ApiClientConstant.Order.Type.REGIMEN'>
                @if (orderedProductsCount === 1) {
                  <span i18n="@@oneProductDeliveredExpTag">{{orderedProductsCount}} Product Delivered</span>
                } @else {
                  <span i18n="@@multipleProductsDeliveredExpTag">{{orderedProductsCount}} Products Delivered</span>
                }
              </span>
              <cs-icon class="tw-h-4 tw-aspect-square tw-ml-2 tw-flex-none" [iconName]="'chevron_right_teal'"></cs-icon>
            </div>
            <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@clickHereToSeeDetails">
              Click here to see details
            </div>
          </div>
        </div>
      }
    </section>
  }
</ng-template>
